import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  CircularProgress,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface MarkDestroyedDialogProps {
  open: boolean;
  mode: 'destroy' | 'restore';
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  error: string | null;
}

export const MarkDestroyedDialog: React.FC<MarkDestroyedDialogProps> = ({
  open,
  mode,
  onClose,
  onConfirm,
  loading,
  error,
}) => {
  const theme = useTheme();
  const fullScreenMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isDestroy = mode === 'destroy';

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth fullScreen={fullScreenMobile}>
      <DialogTitle>{isDestroy ? 'Mark as Destroyed' : 'Restore Item'}</DialogTitle>
      <DialogContent>
        {isDestroy ? (
          <Typography variant="body1">
            This marks the physical artwork as destroyed. The catalog record will be preserved
            and can be restored later.
          </Typography>
        ) : (
          <Typography variant="body1">
            Restore this item? It will return to normal status in your catalog.
          </Typography>
        )}
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color={isDestroy ? 'error' : 'primary'}
          variant="contained"
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : isDestroy ? (
            'Mark as Destroyed'
          ) : (
            'Restore'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
